import SiafLiteApiRepository from "../../external/siafLiteApi";

class SituacaoTributariaIpiService {
  constructor() {
    this.urlBase = "/fiscal/situacoes-tributarias-ipi";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }
}

export default SituacaoTributariaIpiService;
